// userSelectors.js

export const selectPrescriptionDetails = (state) => state.prescription.prescriptionDetails;
export const selectLoading = (state) => state.prescription.loading;
export const selectClickedPrescription = (state) => state.prescription.prescriptionId;
export const selectPrescriptionPage = (state) => state.prescription.page;

